<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <div v-else class="hotels-list">

      <template v-if="table_hotels_cancellation.length">
        <div v-for="(item, index) in table_hotels_cancellation" :key="`hotels_${index}`">
          <AppAccHotel :reservation="item.reservation" :order-number="index + 1" />
        </div>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickHotelsCancellationPagination"
              v-if="pagination_hotels_cancellation.pages > 1"
              v-model="pagination_hotels_cancellation.page"
              :page-count="pagination_hotels_cancellation.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records
            :all="pagination_hotels_cancellation.count"
            :count="table_hotels_cancellation.length"
            :page="pagination_hotels_cancellation.page"
            :limit="40"
          />
        </app-cells>
      </template>
      <div v-else class="no-results no-results--margin">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no reservations yet</div>
      </div>

    </div>
  </div>
</template>

<script>
import { getReservationsHotelsCancellationRequests } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'HotelsCancellationsCancelled',
  components: { AppAccHotel },
  data() {
    return {
      is_loaded: false,
      table_hotels_cancellation: [],
      pagination_hotels_cancellation: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    getReservationsHotelsCancellationRequests({ page: this.pagination_hotels_cancellation.page, page_size: 40, reservation_status: 'stopped' })
      .then(res => {
        this.table_hotels_cancellation = res.data.results
        this.pagination_hotels_cancellation.pages = res.data.pages
        this.pagination_hotels_cancellation.count = res.data.count
        this.is_loaded = true
      })
  },
  methods: {
    fetchHotelsCancellationItems() {
      getReservationsHotelsCancellationRequests({ page: this.pagination_hotels_cancellation.page, page_size: 40, reservation_status: 'stopped' })
        .then(res => {
          this.table_hotels_cancellation = res.data.results
          this.pagination_hotels_cancellation.pages = res.data.pages
          this.pagination_hotels_cancellation.count = res.data.count
        })
    },
    onClickHotelsCancellationPagination(page) {
      this.pagination_hotels_cancellation.page = page
      this.fetchHotelsCancellationItems()
    },
  }
}
</script>
<style scoped lang="sass">
.hotels-list
  max-width: 1100px
</style>